import { formatMoney } from 'accounting'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCog, faPencil, faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, IconWithMenu, Image, Link, Text,
} from '@domain-group/suit-theme'

import useOrder from '@hooks/useOrder'

import type { OrderModel } from '@models/order'

import OrderContainer from '../../../../components/OrderContainer'

import OrderItem from './OrderItem'

interface PendingOrderProps {
  order: OrderModel,
}

const PendingOrder = (props: PendingOrderProps) => {
  const { order } = props

  const orderPayload = useOrder(order)
  const {
    callbacks: {
      confirmOrder,
      createCreditNoteAndDeleteOrder,
      deleteOrder: deleteFn,
      editOrderTotal,
    },
    canApprove,
    filteredOrderItems,
    hasOrderItems,
    isDeletable,
    isOrderable,
    order: {
      id,
      total,
    },
    processingFees,
    provider,
    totalEditable,
  } = orderPayload

  const logoUrl = provider?.alternate_logo?.thumb

  const showAdditionalOptions = isDeletable

  return (
    <OrderContainer>
      <OrderContainer.Items>
        {filteredOrderItems.map(orderItem => (
          <OrderItem
            key={orderItem.id}
            orderItem={orderItem}
          />
        ))}
      </OrderContainer.Items>

      <OrderContainer.Footer>
        <Box alignItems="center" width={['100%', 'auto']}>
          <Image
            backgroundSize="contain"
            borderRadius={5}
            boxProps={{ border: '1px solid', borderColor: 'lineColor' }}
            height={38}
            url={logoUrl!}
            width={60}
          />

          <Box flexDirection="column" fontSize="xsmall" marginLeft="large">
            <Text color="lightGrey">Order #{id}</Text>
            <Text color="bodyFontLightColor" marginTop="small">
              from {provider.title}
            </Text>
          </Box>
        </Box>

        <Box
          alignItems="center"
          justifyContent="flex-end"
          marginLeft={[0, 'auto']}
          marginTop={['large', 0]}
          width={['100%', 'auto']}
        >
          <Box
            alignItems={['flex-start', 'flex-end']}
            flexDirection="column"
            flexShrink={0}
            justifyContent="center"
            marginRight={['auto', 0]}
            width="auto"
          >
            <Box alignItems="center" width="auto">
              <Text fontSize="medium">{formatMoney(total)}</Text>
              {totalEditable && (
                <Link
                  onClick={editOrderTotal}
                  textProps={{ color: 'lightGrey', fontSize: 'xsmall', marginLeft: 'small' }}
                >
                  <FontAwesomeIcon icon={faPencil} />
                </Link>
              )}
            </Box>

            {processingFees > 0 && (
              <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">
                + {formatMoney(processingFees)} Fees
              </Text>
            )}
          </Box>

          {(showAdditionalOptions || isOrderable) && (
            <Box alignItems="center" marginLeft="large" width="auto">
              <IconWithMenu
                boxProps={{ position: 'relative' }}
                icon={(
                  <Button
                    buttonStyle="secondaryUtility"
                    icon={<FontAwesomeIcon icon={faCog} />}
                    size="medium"
                    style={{ height: 38 }}
                  />
                )}
              >
                {/*
                 // @ts-expect-error TS2741 */}
                <IconWithMenu.Menu closeOnClick>
                  <Link
                    key="delete"
                    onClick={() => createCreditNoteAndDeleteOrder({ deleteFn })}
                  >
                    <FontAwesomeIcon icon={faTrashAlt} /> Delete Order
                  </Link>
                </IconWithMenu.Menu>
              </IconWithMenu>

              {hasOrderItems && isOrderable && canApprove && (
                <Button
                  buttonStyle="primaryCreate"
                  // @ts-expect-error
                  marginLeft="small"
                  onClick={confirmOrder}
                  size="medium"
                  style={{ height: 38, width: 110 }}
                >
                  Confirm
                </Button>
              )}
            </Box>
          )}
        </Box>
      </OrderContainer.Footer>
    </OrderContainer>
  )
}

export default PendingOrder
